import { useCallback, useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom"
import { useApi } from "../../../api";
import { SearchBar } from "../../../components/NFT/SearchBar";
import { Numeral } from "../../../components/Numeral";
import { ICargo, INftAsset } from "../../../interfaces";
import { Utils } from "../../../utils";

export const NftSearchPage = () => {
  const [searchParams] = useSearchParams();
  const keyword = searchParams.get('keyword');
  const projectCode = 'NFT';
  const api = useApi(projectCode);
  const [mounted, setMounted] = useState(false);
  const [nftAssets, setAssets] = useState<INftAsset[] | null>(null);
  const navi = useNavigate();

  const search = useCallback((keyword: string | null) => {
    if (keyword) {
      api.searchNft(keyword, (cargo: ICargo) => {
        if (cargo.returnCode === '000000') {
          setAssets(cargo.info); 
        }
      })
    }
  }, [api])

  useEffect(() => {
    if (mounted) return;
    setMounted(true);
    search(keyword);
  }, [keyword, mounted, search])

  return (
    <>
      <div className="mx-auto max-w-2xl py-16 px-4 sm:py-24 sm:px-6 lg:max-w-7xl lg:px-8">
          <h2 className="sr-only">Products</h2>
          <div className="mb-5">
            <SearchBar onSearch={search} />
          </div>
          <div className="grid grid-cols-1 gap-y-10 gap-x-6 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 xl:gap-x-8">
            {nftAssets && nftAssets.map((nftAsset: INftAsset, index: number) => {
              if (!nftAsset.image) return null;
              return (
                <div key={index} className="group cursor-pointer" onClick={() => {
                  navi(`/web/asset/detail/${nftAsset.nftId}`)
                }}>
                  <div className="aspect-w-1 aspect-h-1 w-full overflow-hidden rounded-lg bg-gray-200 xl:aspect-w-7 xl:aspect-h-8">
                    <img src={Utils().normalizeImagePath(nftAsset.image, projectCode)} alt={nftAsset.description} className="h-full w-full object-cover object-center group-hover:opacity-75" />
                  </div>
                  <h3 className="mt-4 text-sm text-gray-700">{nftAsset.name}</h3>
                  <p className="mt-1 text-lg font-medium text-gray-900">$<Numeral value={nftAsset.sellingPrice} /></p>
                </div>
              )
            })}

          </div>
        </div>
    </>
  )
}